import React, { FC, useState } from 'react';

import { PageTitle } from '../common-styles/common-styles';
import { Player } from '../../../database.schema';
import { PlayerEntry } from './player-entry';
import * as CSS from './player-styles';
import { useFetchPlayers } from '../../api/hooks/use-fetch-players';

export const PlayerAdmin: FC = () => {
  const [addPlayer, setAddPlayer] = useState<boolean>(false);
  const [editPlayer, setEditPlayer] = useState<boolean>(false);
  const [editPlayerData, setEditPlayerData] = useState<Player | undefined>();
  const { isLoading, error, data } = useFetchPlayers();

  if (isLoading) {
    return <div>loading..</div>;
  }

  if (error) {
    return <div>error...</div>;
  }
  const players = data as Array<Player>;
  const nextPlayerIndex = players.length;

  if (addPlayer) {
    return <PlayerEntry playerIndex={nextPlayerIndex} resetDataEntry={setAddPlayer} />;
  }
  if (editPlayer && editPlayerData) {
    return (
      <PlayerEntry
        resetDataEntry={setEditPlayer}
        playerIndex={editPlayerData.id - 1}
        name={editPlayerData.name}
        nickName={editPlayerData.nickName}
        playerId={editPlayerData.id}
        admin={editPlayerData?.admin}
        virtual={editPlayerData?.virtual}
        onTour={editPlayerData?.onTour}
      />
    );
  }
  return (
    <div>
      <PageTitle>
        <h2>Player Admin</h2>
      </PageTitle>
      <ul>
        {players.map((player: Player) => (
          <CSS.PlayerListItem key={`player-${player.id}`}>
            <CSS.FlexRow>
              <div>{player.nickName}</div>
              {player.admin && <div>&nbsp; (admin)</div>}
            </CSS.FlexRow>
            <CSS.Button
              onClick={() => {
                setEditPlayerData(player);
                setEditPlayer(true);
              }}
            >
              Edit
            </CSS.Button>
          </CSS.PlayerListItem>
        ))}
      </ul>
      <CSS.Button onClick={() => setAddPlayer(true)}>Add</CSS.Button>
    </div>
  );
};
